export default "__VITE_ASSET__CGpa6IBw__"